import { createSlice } from '@reduxjs/toolkit';

const layoutSlice = createSlice({
    name: 'layout',
    initialState: {
        layout: 'fullscreen',
    },
    reducers: {
        setLayout: (state, action) => ({
            ...state,
            layout: action.payload,
        }),
    },
});

export const { setLayout } = layoutSlice.actions;
export default layoutSlice.reducer;
